import { render, staticRenderFns } from "./ChangeCertificate.vue?vue&type=template&id=55107ec8"
import script from "./ChangeCertificate.vue?vue&type=script&lang=js"
export * from "./ChangeCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports